export default "__VITE_ASSET__DfLj8Auk__"